import Analytics from '@/utils/analytics';
import i18n from '@/utils/i18n';
import React from 'react';
import { BubbleProps } from 'react-native-gifted-chat';
import { ChatActionMessage } from './chat-action-message';
import {
  ChatDetails_ChatMessageOrderStatusUpdateFragment,
  FulfillmentName,
} from '@/types';
import { Message, OnOrderPressType } from './types';
import { OrderStatus } from '@/enums';

const ORDER_STATUS_HEADER_TEXT_MAP: { [status in OrderStatus]?: string } = {
  [OrderStatus.ConfirmedBySupplier]: i18n.t('confirmed'),
  [OrderStatus.Delivered]: i18n.t('delivered'),
  [OrderStatus.OutForDelivery]: i18n.t('delivery_today'),
  [OrderStatus.Rated]: i18n.t('rated'),
  [OrderStatus.ReceivedBySupplier]: i18n.t('received'),
  [OrderStatus.SentToSupplier]: i18n.t('sent'),
  [OrderStatus.ShouldBeDelivered]: i18n.t('delivery_today'),
  [OrderStatus.ViewedBySupplier]: i18n.t('viewed'),
};

const FULFILLMENT_TYPE_TO_ORDER_STATUS_HEADER_TEXT_OVERRIDES_MAP: {
  [fulfillmentType in FulfillmentName]?: {
    [status in OrderStatus]?: string;
  };
} = {
  [FulfillmentName.Pickup]: {
    [OrderStatus.Delivered]: i18n.t('order_picked_up'),
    [OrderStatus.OutForDelivery]: i18n.t('pickup_today'),
    [OrderStatus.ShouldBeDelivered]: i18n.t('pickup_today'),
  },
};

type Props = BubbleProps<Message> & {
  onOrderPress: OnOrderPressType;
};

export const ChatMessageOrderStatusUpdate: React.FC<Props> = ({
  onOrderPress,
  ...rest
}) => {
  const currentMessage = rest.currentMessage as Message;
  const orderStatusUpdate =
    currentMessage.orderStatusUpdate as ChatDetails_ChatMessageOrderStatusUpdateFragment;

  const { order } = orderStatusUpdate;
  const fulfillmentType = order.fulfillment_type as FulfillmentName;
  const status = orderStatusUpdate.status as OrderStatus;
  return (
    <ChatActionMessage
      {...rest}
      buttonText={i18n.t('view_order')}
      onPress={() => {
        const orderUUID = order.uuid;
        Analytics.track('chat_message.view_order_button.press', { orderUUID });

        onOrderPress(order.uuid, order.customer_facing_id);
      }}
      title={
        FULFILLMENT_TYPE_TO_ORDER_STATUS_HEADER_TEXT_OVERRIDES_MAP[
          fulfillmentType
        ]?.[status] || ORDER_STATUS_HEADER_TEXT_MAP[status]!
      }
    />
  );
};
